import { ResponsiveCarousel } from '@packages/shared/src/components/Carousel/ResponsiveCarousel';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import type { ComponentProps, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { recoCarouselMessages } from './messages';

export type RecoCarouselProps = {
  /** Recommendation items */
  children: ReactNode;
  /** Displayed title above the items */
  title: string;
} & ComponentProps<typeof ResponsiveCarousel>;

/**
 * Base component for Product / Category / Brand sliders
 * */
export const RecoCarousel = ({ children, title, loadingState, ...rest }: RecoCarouselProps) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      {title.length > 0 && (
        <header className="text-size-h4 lg:text-size-h3 my-2 px-1.5 lg:px-2">
          {loadingState ? (
            <Skeleton className="w-1/4" />
          ) : (
            // bearer:disable javascript_react_dangerously_set_inner_html
            <span dangerouslySetInnerHTML={{ __html: title }} />
          )}
        </header>
      )}
      <div className="bg-color-grey-light p-1.5 pb-1.5 lg:p-2 lg:pb-2">
        <ResponsiveCarousel
          {...rest}
          aria={{
            buttonPrev: formatMessage(recoCarouselMessages.ariaPrevButton),
            buttonNext: formatMessage(recoCarouselMessages.ariaNextButton),
          }}
          showDots={false}
          hasOffset
          mobile={{ visibleSlides: 2.5, slidesToScroll: 2, gap: 1.5, showArrows: false }}
          tablet={{ visibleSlides: 3.5, slidesToScroll: 3, gap: 1.5 }}
          desktop={{
            visibleSlides: 5.5,
            slidesToScroll: 5,
            gap: 1.5,
          }}
        >
          {children}
        </ResponsiveCarousel>
      </div>
    </div>
  );
};
